const AllGeneList = [
"AAAS",
"AAK1",
"AATF",
"ABCC1",
"ABCF1",
"ABI1",
"ABLIM1",
"ACAD9",
"ACAP2",
"ACBD3",
"ACD",
"ACIN1",
"ACLY",
"ACSS2",
"ACTG1",
"ACTN4",
"ACTR8",
"ADAM17",
"ADAM9",
"ADAR",
"ADARB1",
"ADAT1",
"ADCY6",
"ADD1",
"ADD3",
"ADGRA2",
"ADGRL3",
"ADNP",
"AFAP1",
"AFAP1L2",
"AFDN",
"AFF4",
"AFTPH",
"AGAP1",
"AGAP3",
"AGO2",
"AHCTF1",
"AHDC1",
"AHNAK",
"AHNAK2",
"AJUBA",
"AKAP1",
"AKAP11",
"AKAP13",
"AKAP17A",
"AKAP2",
"AKAP6",
"AKAP8",
"AKT1S1",
"ALAD",
"ALDH3A2",
"ALDOA",
"ALG3",
"ALKBH5",
"ALS2",
"AMFR",
"AMPD2",
"ANAPC1",
"ANAPC2",
"ANK2",
"ANK3",
"ANKHD1",
"ANKIB1",
"ANKLE2",
"ANKRD11",
"ANKRD13D",
"ANKRD54",
"ANKS1A",
"ANKZF1",
"ANLN",
"ANO6",
"ANP32A",
"ANP32B",
"ANTXR1",
"ANXA2",
"AP1AR",
"AP1M1",
"AP3B1",
"AP3D1",
"APBA1",
"APBA3",
"APC",
"APEH",
"API5",
"APIP",
"APTX",
"AR",
"ARAP1",
"ARAP3",
"ARFGAP1",
"ARFGEF1",
"ARFGEF2",
"ARHGAP1",
"ARHGAP17",
"ARHGAP21",
"ARHGAP24",
"ARHGAP26",
"ARHGAP31",
"ARHGAP32",
"ARHGAP35",
"ARHGAP5",
"ARHGEF1",
"ARHGEF10",
"ARHGEF11",
"ARHGEF12",
"ARHGEF16",
"ARHGEF17",
"ARHGEF18",
"ARHGEF2",
"ARHGEF28",
"ARHGEF35",
"ARHGEF5",
"ARHGEF6",
"ARHGEF7",
"ARID1A",
"ARID4A",
"ARID5B",
"ARL6IP4",
"ARL6IP6",
"ARMCX3",
"ARNT",
"ARRB1",
"ARVCF",
"ASAP1",
"ASAP2",
"ASCC2",
"ASF1A",
"ASMTL",
"ASPH",
"ASPSCR1",
"ASS1",
"ASXL2",
"ATAD5",
"ATE1",
"ATF7IP",
"ATG13",
"ATG2B",
"ATG9A",
"ATL3",
"ATN1",
"ATP10D",
"ATP11C",
"ATP13A3",
"ATP13A5",
"ATP8A1",
"ATR",
"ATRIP",
"ATRX",
"ATXN2",
"ATXN2L",
"AUP1",
"AZI2",
"BABAM1",
"BACH1",
"BAD",
"BAG3",
"BAG6",
"BAIAP2L1",
"BAP1",
"BASP1",
"BAZ1A",
"BAZ1B",
"BAZ2A",
"BBS10",
"BCAR1",
"BCAS3",
"BCKDK",
"BCL10",
"BCL11A",
"BCL2L12",
"BCL2L13",
"BCL3",
"BCL7C",
"BCL9L",
"BCLAF1",
"BCLAF3",
"BCOR",
"BDKRB2",
"BICC1",
"BICD2",
"BICRA",
"BICRAL",
"BIN1",
"BIRC6",
"BLNK",
"BLOC1S3",
"BLZF1",
"BMP2K",
"BNIP2",
"BNIP3",
"BOD1L1",
"BOP1",
"BPTF",
"BRAF",
"BRAP",
"BRD1",
"BRD3",
"BRD4",
"BRD8",
"BRD9",
"BRF2",
"BRI3BP",
"BRMS1",
"BRMS1L",
"BRPF1",
"BRWD1",
"BSG",
"BUB1B",
"BUB3",
"BUD13",
"BYSL",
"BZW2",
"C11orf68",
"C12orf45",
"C17orf102",
"C19orf44",
"C1orf131",
"C1orf21",
"C5orf30",
"C7orf50",
"C9orf40",
"C9orf78",
"CAAP1",
"CABIN1",
"CACTIN",
"CAD",
"CADPS2",
"CALCOCO2",
"CALD1",
"CAMK4",
"CAMKK2",
"CAMSAP1",
"CAMSAP2",
"CANT1",
"CANX",
"CAP1",
"CAP2",
"CAPN2",
"CARHSP1",
"CARMIL1",
"CARS",
"CASC3",
"CAST",
"CAV1",
"CAV2",
"CAVIN1",
"CAVIN2",
"CAVIN3",
"CBL",
"CBX3",
"CBX4",
"CC2D1A",
"CCAR2",
"CCDC14",
"CCDC167",
"CCDC25",
"CCDC82",
"CCDC86",
"CCDC88A",
"CCDC9",
"CCDC97",
"CCDC9B",
"CCM2",
"CCNK",
"CCNL1",
"CCNL2",
"CCNY",
"CCNYL1",
"CCP110",
"CCPG1",
"CCT4",
"CCT8",
"CCZ1",
"CD248",
"CD274",
"CD276",
"CD2AP",
"CD2BP2",
"CD3EAP",
"CD44",
"CD97",
"CDC25B",
"CDC26",
"CDC40",
"CDC42EP1",
"CDC5L",
"CDCA3",
"CDH10",
"CDK11A",
"CDK12",
"CDK13",
"CDK14",
"CDK18",
"CDR2L",
"CDS2",
"CDT1",
"CEBPZ",
"CELF1",
"CENPA",
"CEP112",
"CEP164",
"CEP170",
"CEP170B",
"CEP192",
"CEP72",
"CEP76",
"CEP89",
"CEP97",
"CERS2",
"CERT",
"CETN2",
"CFL1",
"CGNL1",
"CHAF1A",
"CHAF1B",
"CHAMP1",
"CHCHD3",
"CHD1",
"CHD2",
"CHD3",
"CHD4",
"CHD8",
"CHERP",
"CHIC2",
"CHL1",
"CHMP2B",
"CHP1",
"CHPF2",
"CHTF18",
"CIAPIN1",
"CIC",
"CIT",
"CLASP1",
"CLCC1",
"CLDN1",
"CLINT1",
"CLIP1",
"CLIP2",
"CLK3",
"CLK4",
"CLMP",
"CLN3",
"CLN6",
"CLNS1A",
"CLOCK",
"CLPP",
"CLVS1",
"CMTR1",
"CNOT2",
"COASY",
"COBLL1",
"COG1",
"COG3",
"COG4",
"COG5",
"COG7",
"COIL",
"COL19A1",
"COL6A3",
"COPB2",
"COPE",
"COPRS",
"COPS3",
"CORO7",
"CPNE3",
"CROCC",
"CRY2",
"CRYBG1",
"CRYBG3",
"CSNK1E",
"CSTF2",
"CTDP1",
"CTIF",
"CTNNA1",
"CTNND1",
"CTPS2",
"CTR9",
"CTTN",
"CTU2",
"CUL4A",
"CUL4B",
"CUSTOS",
"CUX1",
"CWC22",
"CWC25",
"CWF19L2",
"CXorf38",
"DAB2IP",
"DARS2",
"DAXX",
"DBN1",
"DBNL",
"DCAF10",
"DCAF5",
"DCAF6",
"DCAF8",
"DCLK1",
"DCP1A",
"DCP1B",
"DCTN2",
"DCUN1D4",
"DDA1",
"DDB2",
"DDX1",
"DDX10",
"DDX20",
"DDX21",
"DDX23",
"DDX24",
"DDX42",
"DDX50",
"DDX51",
"DDX54",
"DEAF1",
"DEK",
"DENND1A",
"DENND4A",
"DENND4B",
"DENND4C",
"DENND5A",
"DENND5B",
"DENND6A",
"DENR",
"DEPTOR",
"DFFA",
"DGCR8",
"DGKH",
"DHCR7",
"DHX16",
"DHX29",
"DHX30",
"DHX34",
"DHX8",
"DIAPH1",
"DIDO1",
"DIS3L2",
"DISP2",
"DKC1",
"DLC1",
"DLG5",
"DLGAP4",
"DLGAP5",
"DMAP1",
"DMXL1",
"DNAH9",
"DNAJB14",
"DNAJB2",
"DNAJB6",
"DNAJC1",
"DNAJC17",
"DNAJC2",
"DNAJC5",
"DNM1",
"DNM1L",
"DNMT1",
"DNPH1",
"DNTTIP2",
"DOCK1",
"DOCK10",
"DOCK11",
"DOCK4",
"DOCK5",
"DOCK6",
"DOCK9",
"DOP1B",
"DOT1L",
"DPCD",
"DPF2",
"DPM1",
"DPYD",
"DPYSL2",
"DSG2",
"DSN1",
"DSP",
"DST",
"DTNA",
"DTNB",
"DTNBP1",
"DTX2",
"DTX3L",
"DUS3L",
"DUSP16",
"DUSP7",
"DUSP9",
"DYNC1LI1",
"DYNC1LI2",
"DYRK4",
"ECM2",
"EDC3",
"EDC4",
"EEF1AKMT2",
"EEF1B2",
"EEF1D",
"EEF2K",
"EFR3A",
"EFS",
"EGFR",
"EGLN1",
"EHBP1",
"EHBP1L1",
"EHD2",
"EHD4",
"EHMT2",
"EIF2A",
"EIF2AK3",
"EIF2AK4",
"EIF2B5",
"EIF3B",
"EIF3C",
"EIF3F",
"EIF3G",
"EIF3J",
"EIF4B",
"EIF4EBP1",
"EIF4ENIF1",
"EIF4G1",
"EIF4G3",
"EIF5A2",
"EIF5B",
"EIF6",
"ELF1",
"ELF4",
"ELL",
"ELMO1",
"ELMSAN1",
"EMB",
"EMD",
"EME1",
"EML1",
"EML3",
"EML4",
"ENAH",
"ENO1",
"EP300",
"EP400",
"EPB41L2",
"EPB41L3",
"EPN1",
"EPN3",
"EPRS",
"EPS15",
"EPS15L1",
"EPS8L2",
"ERBIN",
"ERCC5",
"ERCC6L",
"EREG",
"ERF",
"ERICH1",
"ERRFI1",
"ESF1",
"ESS2",
"ESYT1",
"ESYT2",
"ETS1",
"ETV3",
"ETV6",
"EVA1A",
"EVI5",
"EVL",
"EXOC1",
"EXOC4",
"EXOSC5",
"EXOSC9",
"EZH2",
"F2R",
"FABP4",
"FAF2",
"FAHD1",
"FAM117A",
"FAM122A",
"FAM122B",
"FAM126B",
"FAM160A2",
"FAM234A",
"FAM234B",
"FAM53B",
"FAM53C",
"FAM76B",
"FAM83B",
"FAM83G",
"FAM83H",
"FAM91A1",
"FANCE",
"FARP1",
"FASN",
"FAT2",
"FBLN1",
"FBN1",
"FBRS",
"FBRSL1",
"FBXO38",
"FBXO4",
"FBXW11",
"FBXW5",
"FBXW9",
"FCHO2",
"FERMT1",
"FERMT2",
"FEZ1",
"FEZ2",
"FGD4",
"FGD6",
"FGFR1OP",
"FHL2",
"FHOD1",
"FKBP15",
"FKBP1A",
"FKBP4",
"FKBP5",
"FLAD1",
"FLII",
"FLNA",
"FLNB",
"FLOT1",
"FMNL1",
"FMNL2",
"FN1",
"FNBP4",
"FNDC3A",
"FNDC3B",
"FOSL1",
"FOSL2",
"FOXC1",
"FOXC2",
"FOXK1",
"FOXK2",
"FOXP4",
"FRA10AC1",
"FRMD3",
"FRMD6",
"FRMD8",
"FRY",
"FTH1",
"FTO",
"FTSJ1",
"FTSJ3",
"FUBP1",
"FUBP3",
"FUNDC2",
"FYTTD1",
"FZD6",
"G3BP1",
"GALNT4",
"GAPDH",
"GAPVD1",
"GAS2L1",
"GATAD2A",
"GBF1",
"GCFC2",
"GDI2",
"GEMIN5",
"GFPT2",
"GIGYF1",
"GIMAP7",
"GINS2",
"GIPC1",
"GIT1",
"GJA1",
"GLCE",
"GLE1",
"GLI3",
"GLUD2",
"GLYR1",
"GMDS",
"GMIP",
"GNG12",
"GOLGA4",
"GOLGB1",
"GOLIM4",
"GOLPH3",
"GORASP1",
"GP1BA",
"GPALPP1",
"GPAM",
"GPAT3",
"GPATCH4",
"GPATCH8",
"GPCPD1",
"GPHN",
"GPI",
"GPSM1",
"GRAMD1A",
"GRK6",
"GRN",
"GRWD1",
"GSE1",
"GTF2F2",
"GTF2I",
"GTF2IRD1",
"GTF3A",
"GTF3C1",
"GTF3C2",
"GTF3C3",
"GTF3C4",
"GTPBP1",
"GTSE1",
"GYS1",
"H1-4",
"H1FX",
"H2AFX",
"H2AFY",
"HACE1",
"HADHA",
"HARS2",
"HAS2",
"HAUS7",
"HBP1",
"HCAR2",
"HCFC1",
"HCK",
"HDAC1",
"HDAC2",
"HDAC3",
"HDAC4",
"HDAC7",
"HDGF",
"HDGFL2",
"HDLBP",
"HEATR5B",
"HEATR6",
"HECTD1",
"HECTD4",
"HECW2",
"HELZ",
"HELZ2",
"HERC1",
"HIC1",
"HIRIP3",
"HIST2H3A",
"HIVEP2",
"HIVEP3",
"HJURP",
"HK1",
"HLA-H",
"HLCS",
"HMGA1",
"HMGCS1",
"HMGXB4",
"HNRNPA2B1",
"HNRNPA3",
"HNRNPC",
"HNRNPD",
"HNRNPH1",
"HNRNPUL2",
"HOMER3",
"HOMEZ",
"HP1BP3",
"HPS5",
"HRH1",
"HS1BP3",
"HSF1",
"HSP90AA1",
"HSPA4",
"HSPB1",
"HSPBP1",
"HSPH1",
"HTATSF1",
"HTT",
"HUWE1",
"HYPK",
"IARS",
"ICAM1",
"ICE1",
"ICK",
"IER3",
"IFI16",
"IFRD2",
"IFT140",
"IFT22",
"IFT43",
"IGF2BP2",
"IGF2R",
"IKBKB",
"IKBKE",
"IKZF2",
"IKZF4",
"IL1RAP",
"IL32",
"IL33",
"ILF3",
"ILKAP",
"INCENP",
"INF2",
"ING4",
"INPP5E",
"INPP5F",
"INTS1",
"INTS12",
"INTS13",
"INTS7",
"IQGAP1",
"IRAK2",
"IRF2BP1",
"IRF2BP2",
"IRF2BPL",
"IRF3",
"IRS1",
"IRS2",
"IRX2",
"ISCU",
"ITFG2",
"ITGA2",
"ITGA3",
"ITGA5",
"ITGB4",
"ITPKB",
"ITPR1",
"ITPR3",
"ITPRID2",
"ITPRIPL2",
"ITSN1",
"ITSN2",
"IVNS1ABP",
"IWS1",
"JCAD",
"JMJD1C",
"JMY",
"JPT1",
"JPT2",
"JUN",
"JUND",
"KANK1",
"KANK2",
"KANSL1",
"KAT14",
"KAT5",
"KAT6A",
"KAT7",
"KATNA1",
"KATNB1",
"KBTBD11",
"KCNAB2",
"KCNQ5",
"KCNU1",
"KCTD1",
"KCTD12",
"KCTD3",
"KDM1A",
"KDM1B",
"KDM2A",
"KDM2B",
"KDM3A",
"KDM3B",
"KHNYN",
"KHSRP",
"KIAA0100",
"KIAA0556",
"KIAA0754",
"KIAA0930",
"KIAA1109",
"KIAA1143",
"KIAA1217",
"KIAA1522",
"KIAA1671",
"KIDINS220",
"KIF11",
"KIF15",
"KIF16B",
"KIF1B",
"KIF1C",
"KIF20A",
"KIF21A",
"KIF4A",
"KIF5B",
"KIFAP3",
"KLC1",
"KLC2",
"KLC4",
"KLF13",
"KLHDC9",
"KLHL22",
"KMT2A",
"KMT2B",
"KMT2C",
"KMT2D",
"KNSTRN",
"KPNB1",
"KRI1",
"KRTCAP2",
"KSR1",
"KTN1",
"L3MBTL2",
"L3MBTL3",
"LAMTOR1",
"LARP1",
"LARP1B",
"LARP4",
"LARP4B",
"LARP7",
"LAS1L",
"LASP1",
"LBR",
"LCA5",
"LDHA",
"LEMD2",
"LEMD3",
"LEO1",
"LIG1",
"LIMA1",
"LIMCH1",
"LIMD1",
"LIN54",
"LLGL2",
"LMNA",
"LMNB1",
"LMNB2",
"LMO7",
"LMOD1",
"LMTK2",
"LNPK",
"LPIN1",
"LPIN3",
"LRBA",
"LRCH1",
"LRCH3",
"LRFN4",
"LRMDA",
"LRP1",
"LRRC47",
"LRRFIP1",
"LRRFIP2",
"LRWD1",
"LSM11",
"LSM14A",
"LSM7",
"LSP1",
"LSR",
"LTB4R2",
"LUZP1",
"LYN",
"LYST",
"LZTS2",
"M6PR",
"MACF1",
"MACO1",
"MADD",
"MAGED2",
"MAGI3",
"MAP11",
"MAP1A",
"MAP1B",
"MAP1S",
"MAP2K2",
"MAP3K11",
"MAP3K2",
"MAP3K20",
"MAP3K5",
"MAP3K6",
"MAP3K8",
"MAP4",
"MAP4K4",
"MAP7D1",
"MAP9",
"MAPK14",
"MAPK1IP1L",
"MAPK8IP3",
"MAPKAP1",
"MAPKBP1",
"MAPRE1",
"MARCKS",
"MARS",
"MAST4",
"MAT2B",
"MAVS",
"MBD2",
"MBD4",
"MBIP",
"MBLAC1",
"MBOAT2",
"MCC",
"MCM2",
"MCM3",
"MCM3AP",
"MCMBP",
"MCTP2",
"MDC1",
"MDH1",
"MDN1",
"MECP2",
"MED12",
"MED13",
"MED14",
"MED15",
"MED24",
"MED26",
"MEDAG",
"MEF2A",
"MEF2C",
"MEIS1",
"MEPCE",
"METTL14",
"METTL16",
"METTL22",
"MFSD5",
"MIA2",
"MIA3",
"MIB2",
"MICAL2",
"MICAL3",
"MICALL1",
"MICALL2",
"MIEF1",
"MIER1",
"MKI67",
"MLF1",
"MLLT1",
"MLLT6",
"MMACHC",
"MME",
"MMP1",
"MMTAG2",
"MOCOS",
"MOCS2",
"MOCS3",
"MON1B",
"MORC2",
"MPDZ",
"MPHOSPH10",
"MPHOSPH8",
"MPRIP",
"MPZL1",
"MRC2",
"MRPS16",
"MRPS36",
"MRTFB",
"MSH6",
"MSL1",
"MSL3",
"MSX1",
"MTA1",
"MTCH1",
"MTCL1",
"MTDH",
"MTFR1",
"MTFR1L",
"MTMR12",
"MTMR3",
"MTMR6",
"MVD",
"MVP",
"MXRA7",
"MYBBP1A",
"MYCBP2",
"MYCT1",
"MYH10",
"MYH9",
"MYLK",
"MYO18A",
"MYO9A",
"MYO9B",
"MYOF",
"MYPN",
"N4BP1",
"NAA10",
"NAA15",
"NAA30",
"NAA38",
"NAB1",
"NAB2",
"NAF1",
"NAMPT",
"NAP1L1",
"NASP",
"NAV1",
"NAV2",
"NBAS",
"NBN",
"NCAPD2",
"NCAPG",
"NCAPH2",
"NCBP1",
"NCBP3",
"NCK1",
"NCL",
"NCOA1",
"NCOA2",
"NCOA3",
"NCOA5",
"NCOA7",
"NCOR1",
"NCOR2",
"NDC1",
"NDEL1",
"NDRG1",
"NDUFV3",
"NECTIN1",
"NEDD4",
"NEDD4L",
"NEK1",
"NEK3",
"NEK9",
"NELFA",
"NELFB",
"NELFE",
"NEMF",
"NES",
"NEURL4",
"NEXN",
"NF1",
"NF2",
"NFATC2IP",
"NFATC3",
"NFIA",
"NFIC",
"NFRKB",
"NGDN",
"NHSL1",
"NIBAN2",
"NID1",
"NIFK",
"NIPBL",
"NKTR",
"NMBR",
"NMD3",
"NME2P1",
"NMNAT1",
"NMT2",
"NOB1",
"NOC2L",
"NOL4L",
"NOL8",
"NOLC1",
"NONO",
"NOP14",
"NOP2",
"NOP56",
"NOP58",
"NOSIP",
"NPM1",
"NR1H3",
"NR3C1",
"NRBP1",
"NRDC",
"NSD3",
"NSRP1",
"NSUN2",
"NSUN5P2",
"NUCKS1",
"NUDC",
"NUDT9",
"NUFIP2",
"NUMA1",
"NUMB",
"NUMBL",
"NUP107",
"NUP153",
"NUP160",
"NUP188",
"NUP214",
"NUP35",
"NUP50",
"NUP54",
"NUP88",
"NUP98",
"OCIAD1",
"OGFR",
"OLFML2A",
"OPTN",
"OSBP",
"OSBPL3",
"OSBPL5",
"OSBPL6",
"OSBPL7",
"OSBPL8",
"OSTF1",
"OSTM1",
"OTUD4",
"OTULIN",
"OXSR1",
"PA2G4",
"PACS1",
"PACSIN3",
"PAF1",
"PAGR1",
"PAICS",
"PAK1",
"PAK1IP1",
"PAK2",
"PAK4",
"PAK6",
"PALLD",
"PAM16",
"PAN2",
"PANK4",
"PAPOLA",
"PAPOLG",
"PARD3",
"PARD3B",
"PARG",
"PARN",
"PARP4",
"PARVA",
"PATJ",
"PATL1",
"PAXBP1",
"PAXX",
"PBDC1",
"PBK",
"PBRM1",
"PBXIP1",
"PCBP1",
"PCBP2",
"PCDH7",
"PCDHGC3",
"PCF11",
"PCGF6",
"PCIF1",
"PCM1",
"PCNT",
"PCYT1A",
"PCYT1B",
"PDAP1",
"PDCD11",
"PDCD4",
"PDCD5",
"PDE2A",
"PDE3B",
"PDE4A",
"PDE4B",
"PDE8A",
"PDGFRB",
"PDLIM1",
"PDLIM4",
"PDLIM7",
"PDPK2P",
"PDS5B",
"PDZD8",
"PEAK1",
"PEBP1",
"PEG10",
"PELO",
"PELP1",
"PEX19",
"PFDN4",
"PFKFB2",
"PFKFB3",
"PFKL",
"PFKP",
"PGM2",
"PGRMC1",
"PGRMC2",
"PHACTR2",
"PHACTR4",
"PHB2",
"PHC3",
"PHF12",
"PHF2",
"PHF20",
"PHF21A",
"PHF3",
"PHF6",
"PHIP",
"PHKA1",
"PHKA2",
"PHLDA2",
"PHLDB1",
"PHLDB2",
"PHRF1",
"PI4K2A",
"PI4KB",
"PIAS1",
"PIEZO1",
"PIK3C2A",
"PIK3C3",
"PIK3R2",
"PIP4P1",
"PIP5K1A",
"PITPNC1",
"PITPNM2",
"PITX1",
"PJA1",
"PKD2",
"PKM",
"PKMYT1",
"PKN1",
"PKN2",
"PKP3",
"PLCB3",
"PLCD3",
"PLCH2",
"PLEC",
"PLEKHA2",
"PLEKHA4",
"PLEKHA5",
"PLEKHF1",
"PLEKHG3",
"PLEKHG4",
"PLEKHG5",
"PLEKHN1",
"PLEKHO2",
"PLIN3",
"PLPP3",
"PLXDC2",
"PLXNC1",
"PML",
"PMS2CL",
"PNISR",
"PNKP",
"PNN",
"PNPLA6",
"PNPO",
"POGZ",
"POLD3",
"POLE",
"POLR2A",
"POLR2M",
"POLR3C",
"POLR3E",
"POLR3G",
"POM121C",
"POP1",
"POP5",
"POU2F1",
"PPA2",
"PPAN",
"PPFIA1",
"PPFIBP1",
"PPHLN1",
"PPIG",
"PPIL4",
"PPIP5K1",
"PPIP5K2",
"PPM1G",
"PPME1",
"PPP1R10",
"PPP1R12A",
"PPP1R12C",
"PPP1R18",
"PPP1R2B",
"PPP1R35",
"PPP1R37",
"PPP1R3D",
"PPP1R9B",
"PPP2CA",
"PPP2R3A",
"PPP2R5D",
"PPP3CB",
"PPP6R1",
"PPP6R2",
"PPP6R3",
"PRAG1",
"PRCC",
"PRDM2",
"PRDX6",
"PRICKLE3",
"PRKAA1",
"PRKAB1",
"PRKAB2",
"PRKAR1B",
"PRKAR2A",
"PRKCA",
"PRKCD",
"PRKCE",
"PRKD1",
"PRKD3",
"PRKDC",
"PRKY",
"PRMT3",
"PRMT6",
"PROM2",
"PROSER2",
"PROX1",
"PRPF31",
"PRPF38B",
"PRPF40A",
"PRPF40B",
"PRPF4B",
"PRR11",
"PRR12",
"PRR14",
"PRR5",
"PRRC2A",
"PRRC2B",
"PRRC2C",
"PSD3",
"PSEN2",
"PSIP1",
"PSMA3",
"PSMB10",
"PSMD1",
"PSMD2",
"PSME2",
"PSMF1",
"PSMG1",
"PSPC1",
"PTBP1",
"PTBP3",
"PTDSS1",
"PTDSS2",
"PTEN",
"PTGR2",
"PTK2",
"PTK2B",
"PTOV1",
"PTPN1",
"PTPN12",
"PTPN13",
"PTPN14",
"PTPN2",
"PTPRA",
"PTPRG",
"PTS",
"PTTG2",
"PUF60",
"PUM2",
"PURB",
"PUS1",
"PUS7",
"PVR",
"PWP1",
"PWWP2A",
"PWWP2B",
"PXN",
"PYGO2",
"QSER1",
"R3HDM1",
"RAB11FIP5",
"RAB3IL1",
"RAB8A",
"RABGAP1",
"RABGAP1L",
"RABGEF1",
"RABL6",
"RACGAP1",
"RAD18",
"RAD21",
"RAD23A",
"RAD23B",
"RAD9A",
"RAF1",
"RAI1",
"RAI14",
"RALBP1",
"RALGAPA2",
"RALGAPB",
"RALGPS2",
"RALY",
"RAMAC",
"RANBP1",
"RANBP2",
"RANBP3",
"RANGAP1",
"RAP1GAP2",
"RAPGEF1",
"RAPGEF6",
"RAPH1",
"RASA1",
"RASAL3",
"RAVER1",
"RB1",
"RB1CC1",
"RBBP6",
"RBBP8",
"RBL2",
"RBM12B",
"RBM14",
"RBM15",
"RBM15B",
"RBM23",
"RBM26",
"RBM27",
"RBM33",
"RBM34",
"RBM4",
"RBM42",
"RBM6",
"RBM8A",
"RBMS2",
"RBMX2",
"RCC1",
"RCC2",
"RCOR1",
"RCOR3",
"REEP3",
"REEP4",
"RELCH",
"REPS1",
"RERE",
"REST",
"RETREG2",
"RETREG3",
"RFC1",
"RFC3",
"RFFL",
"RFTN1",
"RFX5",
"RFX7",
"RGL1",
"RGL2",
"RGS3",
"RHBDF1",
"RHBDF2",
"RIC1",
"RIC8A",
"RICTOR",
"RIF1",
"RILPL1",
"RIN1",
"RING1",
"RIOK1",
"RIOK2",
"RIOX2",
"RIPK2",
"RMDN3",
"RMI1",
"RNF123",
"RNF14",
"RNF213",
"RNF31",
"RNF34",
"RNH1",
"RNPC3",
"RNPEP",
"ROCK2",
"RPA1",
"RPAP1",
"RPAP3",
"RPGR",
"RPL18A",
"RPL29",
"RPLP0P6",
"RPP30",
"RPP38",
"RPRD1A",
"RPRD1B",
"RPRD2",
"RPS3A",
"RPS6KA3",
"RPS6KA4",
"RPS6KC1",
"RPTOR",
"RPUSD1",
"RPUSD2",
"RRAD",
"RRBP1",
"RREB1",
"RRM2",
"RRP12",
"RRP36",
"RRP7A",
"RRP8",
"RSBN1",
"RSF1",
"RSL1D1",
"RSRC2",
"RTKN",
"RTN4",
"RUNX2",
"RUSC2",
"RWDD2B",
"RYBP",
"S100A11",
"S100A13",
"S100A16",
"S100A9",
"S1PR3",
"SAAL1",
"SACS",
"SAFB",
"SAMD4A",
"SAMHD1",
"SAP30BP",
"SAR1A",
"SARM1",
"SART1",
"SASH1",
"SCAF1",
"SCAF11",
"SCAF4",
"SCAF8",
"SCAMP1",
"SCAMP3",
"SCAPER",
"SCARF2",
"SCFD1",
"SCLT1",
"SCLY",
"SCRIB",
"SCRN2",
"SDAD1",
"SDC1",
"SDC2",
"SDCBP",
"SDE2",
"SEC14L2",
"SEC16A",
"SEC22B",
"SEC23IP",
"SEC24B",
"SEC24D",
"SEC31A",
"SEC62",
"SEC63",
"SEH1L",
"SELENON",
"SEMA4B",
"SEMA6B",
"SENP3",
"SENP6",
"SEPTIN10",
"SEPTIN2",
"SEPTIN9",
"SERINC1",
"SERTAD4",
"SET",
"SETD1A",
"SETD1B",
"SETD2",
"SETX",
"SF1",
"SF3A1",
"SF3B2",
"SFMBT1",
"SFN",
"SFSWAP",
"SGMS1",
"SGPP1",
"SGTA",
"SGTB",
"SH2B1",
"SH2D4A",
"SH2D5",
"SH3BP1",
"SH3BP2",
"SH3BP5",
"SH3BP5L",
"SH3GL1",
"SH3KBP1",
"SH3PXD2A",
"SH3PXD2B",
"SHARPIN",
"SHROOM2",
"SIK1B",
"SIK2",
"SIK3",
"SIN3A",
"SIN3B",
"SIPA1",
"SIPA1L1",
"SIPA1L2",
"SIPA1L3",
"SIRT1",
"SIRT6",
"SKA2",
"SKIV2L",
"SLAIN2",
"SLBP",
"SLC10A6",
"SLC12A4",
"SLC12A6",
"SLC12A7",
"SLC15A4",
"SLC16A1",
"SLC16A3",
"SLC16A7",
"SLC19A1",
"SLC1A5",
"SLC20A1",
"SLC20A2",
"SLC26A6",
"SLC2A9",
"SLC30A6",
"SLC33A1",
"SLC35A5",
"SLC35B2",
"SLC35C2",
"SLC35G2",
"SLC36A4",
"SLC39A10",
"SLC39A6",
"SLC39A7",
"SLC39A8",
"SLC4A1AP",
"SLC4A4",
"SLC4A7",
"SLC66A2",
"SLC7A11",
"SLC7A2",
"SLC7A6OS",
"SLC9A1",
"SLC9A3R1",
"SLCO4A1",
"SLIRP",
"SLK",
"SLTM",
"SLX4",
"SMAD5",
"SMAP2",
"SMARCA2",
"SMARCA4",
"SMARCAD1",
"SMARCC1",
"SMARCC2",
"SMC3",
"SMC4",
"SMC5",
"SMG1",
"SMPD4",
"SNAI2",
"SNAP23",
"SNAPIN",
"SND1",
"SNIP1",
"SNRNP70",
"SNTB2",
"SNURFL",
"SNX12",
"SNX15",
"SNX17",
"SNX2",
"SNX24",
"SOGA1",
"SON",
"SORBS2",
"SORBS3",
"SOS1",
"SOWAHC",
"SP100",
"SP110",
"SPAG9",
"SPANXB1",
"SPARCL1",
"SPATS2L",
"SPCS1",
"SPECC1",
"SPECC1L",
"SPEN",
"SPHK1",
"SPICE1",
"SPIN1",
"SPINDOC",
"SPRY4",
"SPTAN1",
"SPTBN1",
"SPTBN2",
"SQOR",
"SQSTM1",
"SRA1",
"SRC",
"SRCAP",
"SRFBP1",
"SRGAP2B",
"SRP68",
"SRP72",
"SRPK1",
"SRPRB",
"SRRM1",
"SRRM2",
"SRRT",
"SRSF11",
"SRSF4",
"SRSF5",
"SRSF6",
"SRSF7",
"SRSF8",
"SRSF9",
"SSB",
"SSH2",
"SSH3",
"SSR3",
"ST13",
"ST5",
"STAM",
"STARD10",
"STARD13",
"STAT1",
"STAT5B",
"STAU2",
"STBD1",
"STIM1",
"STIM2",
"STK10",
"STK11",
"STK11IP",
"STK26",
"STK3",
"STK32C",
"STK39",
"STMN1",
"STMN3",
"STOM",
"STOML2",
"STRADA",
"STRIP2",
"STUB1",
"STX18",
"STX4",
"STX7",
"STXBP5",
"SUB1",
"SUCO",
"SUDS3",
"SUFU",
"SUGP2",
"SUPT16H",
"SUPT5H",
"SUPT6H",
"SUPT7L",
"SURF2",
"SURF6",
"SUSD5",
"SVIL",
"SYAP1",
"SYDE1",
"SYMPK",
"SYNE2",
"SYNJ1",
"SYNJ2",
"SYNPO",
"SYNPO2",
"SYNRG",
"SZRD1",
"SZT2",
"TAB3",
"TACC2",
"TACC3",
"TAF12",
"TAF15",
"TAF1D",
"TAF3",
"TAF6",
"TAF9",
"TAGLN2",
"TANC2",
"TANK",
"TAOK1",
"TAOK3",
"TAP1",
"TARBP2",
"TASOR",
"TASOR2",
"TAX1BP1",
"TBC1D10B",
"TBC1D15",
"TBC1D17",
"TBC1D2",
"TBC1D22B",
"TBC1D25",
"TBC1D2B",
"TBC1D4",
"TBC1D5",
"TBC1D9B",
"TBCK",
"TBX2",
"TCEA1",
"TCEAL3",
"TCF12",
"TCF20",
"TCF4",
"TCOF1",
"TCP11L1",
"TDRD5",
"TECR",
"TELO2",
"TEP1",
"TERF2",
"TES",
"TESK1",
"TET2",
"TEX2",
"TFAP4",
"TFIP11",
"TFPT",
"TGFB1I1",
"TGOLN2",
"THOC1",
"THOC2",
"THRAP3",
"THUMPD1",
"TIMELESS",
"TJAP1",
"TJP1",
"TJP2",
"TK1",
"TLE3",
"TLE5",
"TLN2",
"TMBIM1",
"TMCC3",
"TMEM115",
"TMEM132A",
"TMEM154",
"TMEM184B",
"TMEM192",
"TMEM201",
"TMEM209",
"TMEM245",
"TMEM247",
"TMEM259",
"TMEM40",
"TMEM45A",
"TMEM63B",
"TMEM87A",
"TMEM94",
"TMF1",
"TMPO",
"TMX1",
"TNC",
"TNFAIP3",
"TNFRSF19",
"TNIK",
"TNKS1BP1",
"TNPO1",
"TNRC18",
"TNRC6B",
"TNRC6C",
"TNS1",
"TNS2",
"TNS3",
"TOB1",
"TOE1",
"TOMM34",
"TOMM70",
"TOP2A",
"TOP2B",
"TOR1AIP1",
"TOR1AIP2",
"TOX2",
"TP53",
"TP53BP1",
"TP63",
"TP73",
"TPCN1",
"TPD52L2",
"TPGS1",
"TPI1",
"TPM3",
"TPRN",
"TRAF1",
"TRAFD1",
"TRAM1",
"TRAPPC12",
"TRAPPC8",
"TRERF1",
"TREX1",
"TRIM11",
"TRIM16",
"TRIM21",
"TRIM22",
"TRIM24",
"TRIM25",
"TRIM28",
"TRIM33",
"TRIM40",
"TRIM42",
"TRIM44",
"TRIM47",
"TRIM56",
"TRIO",
"TRIP10",
"TRIP12",
"TRIT1",
"TRMT1",
"TRMT13",
"TRMT61A",
"TRPM6",
"TRPT1",
"TSC2",
"TSC22D3",
"TSC22D4",
"TSHZ1",
"TSR3",
"TSSC4",
"TTC28",
"TTC33",
"TTC39B",
"TTC7A",
"TTK",
"TUBA1B",
"TUSC1",
"TWF1",
"TWISTNB",
"TXLNA",
"TXLNG",
"TXNRD3",
"U2AF1L5",
"UBA1",
"UBA52",
"UBAC1",
"UBAP1",
"UBAP2L",
"UBE2E2",
"UBE2E3",
"UBE2J1",
"UBE2O",
"UBL7",
"UBN1",
"UBR1",
"UBR3",
"UBR4",
"UBR7",
"UBTF",
"UCKL1",
"UFD1",
"UHRF1",
"UHRF1BP1L",
"UHRF2",
"UIMC1",
"ULK1",
"UNG",
"UNK",
"UNKL",
"UPF3B",
"UPP1",
"UQCRC1",
"URI1",
"USO1",
"USP1",
"USP10",
"USP15",
"USP16",
"USP20",
"USP24",
"USP33",
"USP34",
"USP36",
"USP39",
"USP4",
"USP47",
"USP5",
"USP8",
"UTP14A",
"UTP18",
"UTP20",
"VAMP3",
"VAMP4",
"VANGL2",
"VAPB",
"VASP",
"VCAN",
"VCL",
"VDAC1",
"VDAC2",
"VIM",
"VIPAS39",
"VIRMA",
"VPS13B",
"VPS13C",
"VPS13D",
"VPS4A",
"VPS4B",
"VPS50",
"VPS8",
"VSIG4",
"WAC",
"WAPL",
"WARS",
"WASHC2A",
"WASHC4",
"WBP4",
"WDR20",
"WDR33",
"WDR4",
"WDR43",
"WDR44",
"WDR55",
"WDR62",
"WDR7",
"WDR74",
"WDR75",
"WDR77",
"WDTC1",
"WEE1",
"WIPI2",
"WIZ",
"WNK1",
"WRAP53",
"WRN",
"WTAP",
"WWP2",
"XPC",
"XPNPEP1",
"XPO6",
"XRCC1",
"XRCC4",
"XRCC5",
"XRCC6",
"XRN2",
"YAP1",
"YIPF1",
"YJU2",
"YRDC",
"YTHDC1",
"YTHDC2",
"YY1AP1",
"ZBED4",
"ZBTB11",
"ZBTB17",
"ZBTB21",
"ZBTB7A",
"ZC3H11A",
"ZC3H12A",
"ZC3H13",
"ZC3H14",
"ZC3H15",
"ZC3H18",
"ZC3H8",
"ZC3HAV1",
"ZC3HC1",
"ZCCHC8",
"ZDBF2",
"ZDHHC5",
"ZFC3H1",
"ZFHX3",
"ZFP36L1",
"ZFP36L2",
"ZFP91",
"ZFR",
"ZFYVE16",
"ZFYVE19",
"ZFYVE26",
"ZFYVE9",
"ZHX3",
"ZKSCAN1",
"ZKSCAN8",
"ZMYM3",
"ZMYM4",
"ZMYND8",
"ZNF106",
"ZNF148",
"ZNF263",
"ZNF275",
"ZNF276",
"ZNF280C",
"ZNF316",
"ZNF318",
"ZNF358",
"ZNF362",
"ZNF423",
"ZNF428",
"ZNF446",
"ZNF462",
"ZNF512B",
"ZNF516",
"ZNF532",
"ZNF574",
"ZNF579",
"ZNF592",
"ZNF609",
"ZNF618",
"ZNF622",
"ZNF629",
"ZNF638",
"ZNF687",
"ZNF692",
"ZNF768",
"ZNF770",
"ZNF777",
"ZNF787",
"ZNF830",
"ZNF91",
"ZNHIT3",
"ZNHIT6",
"ZNRF2",
"ZRANB1",
"ZRSR2",
"ZSCAN5B",
"ZSWIM8",
"ZYX",
"ZZEF1",
"ZZZ3"
];

export default AllGeneList;